import { render, staticRenderFns } from "./citys.vue?vue&type=template&id=247564ad&"
import script from "./citys.vue?vue&type=script&lang=js&"
export * from "./citys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports